<template>
  <div>
    <Modal v-model="userForm" :title="title" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
       
        <Row>
           <Col span="24">
                <FormItem label="来源:" prop="source" :class="{requireStar:true}" >
                  <Input v-model="formValidate.source" placeholder="如:携程" ></Input>
                </FormItem>
            </Col>
           <Col span="24">
                <FormItem label="标题:" prop="title"  :class="{requireStar:true}" >
                  <Input v-model="formValidate.title"  placeholder="如:西安+西安城墙(以加号分割景区)" ></Input>
                </FormItem>
            </Col>
             <Col span="24">
                <FormItem label="类别:" prop="title_type" :class="{requireStar:true}" >
                  <Input v-model="formValidate.title_type"  placeholder="如:自由行跟团游等"></Input>
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem label="价格:" prop="price" :class="{requireStar:true}" >
                  <Input v-model="formValidate.price" placeholder="" ></Input>
                </FormItem>
            </Col> 
             
        </Row>
       
        
  
       
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Bus from '@/utils/bus.js'
  export default {
    components:{
    },
    data() {
      return {
        userForm: false,
        title:'',
      
        formValidate: {
          _id: '',
          keyword: '',
          price: '',
          source: '',
          title: '',
          title_time: '',
          title_type: '',
        },
        ruleValidate: {
          price: [{
              required: true,
              message: '价格不能为空',
              trigger: 'change'
            },{ message: '只能输入数字', trigger:'change', pattern:/^[0-9]*$/,}],
          title: [{
            required: true,
            message: '标题不能为空',
            trigger: 'change'
          }],
           source: [{
            required: true,
            message: '来源不能为空',
            trigger: 'change'
          }],
          title_type: [{
            required: true,
            message: '类别不能为空',
            trigger: 'change'
          }],
        },
      }
    },

    methods: {
      openModal(title,row) {
        this.title =title
        this.userForm = true
        this.handleReset("formValidate");
        if(row!=null){
          this.formValidate=row
          this.formValidate.price=row.price
        }
      },  
    
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let url =  'api/reference_data/add_one_data' 
            let myData = {
              source: this.formValidate.source,
              title: this.formValidate.title,
              title_type: this.formValidate.title_type,
              price: this.formValidate.price,
              
            }
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
             if (response.data.code == 200) {
                this.$Message.success(response.data.msg);
                this.$parent.loadPage();
              } else {
                 this.$Message.error(response.data.msg);
              }
              this.userForm = false;
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
        this.$parent.loadPage();
      },
    
    },
    mounted() {
    },
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/minprince/MinPrinceAdd.vue